import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { LoggingService } from '../../shared/services/logging/logging.service';

@Injectable()
export class CustomerSearchService extends BaseApiService {
    constructor(private _loggingService: LoggingService) {
        super();
    }

    searchIndividuals(IndividualSearchCriteria) {
        return this.post('Customer/Search/SearchIndividualByName', IndividualSearchCriteria, this.replacer).pipe(
            catchError((error) => this.handleError(error)));
    }

    searchOrganizations(OrganizationSearchCriteria) {
        return this.post('Customer/Search/SearchOrganizationByName', OrganizationSearchCriteria, this.replacer).pipe(
            catchError((error) => this.handleError(error)));
    }

    getNames(customerNumberId) {
        return this.get('Customer/' + customerNumberId + '/Names');
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error) {
            var errorObject = {
                httpStatus: error.status,
                response: error.error
            };
            return observableThrowError(errorObject);
        } else {
            return observableThrowError('Server error');
        }
    }

    private replacer(key, value) {
        if (value === '') {
            return undefined;
        }

        return value;
    }
}
